import { render, staticRenderFns } from "./AdminUtilityUmbDeleteLinkedAccount.vue?vue&type=template&id=a7275550"
import script from "./AdminUtilityUmbDeleteLinkedAccount.vue?vue&type=script&lang=ts"
export * from "./AdminUtilityUmbDeleteLinkedAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports